import { motion, AnimatePresence } from "framer-motion";

// Fullscreen overlay shown briefly when a gift is sent (TikTok / Moj style).
export default function GiftFlash({ gift, onDone }) {
  if (!gift) return null;
  // 8 emoji burst around the center
  const ring = Array.from({ length: 10 });
  return (
    <AnimatePresence>
      <motion.div
        key={gift.id + Date.now()}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.18 }}
        onAnimationComplete={() => setTimeout(onDone, 1300)}
        className="pointer-events-none fixed inset-0 z-[90] flex items-center justify-center"
        data-testid="gift-flash"
      >
        {/* Backdrop pulse */}
        <motion.div
          initial={{ scale: 0.5, opacity: 0.4 }}
          animate={{ scale: 2.6, opacity: 0 }}
          transition={{ duration: 1.1, ease: "easeOut" }}
          className="absolute w-40 h-40 rounded-full bg-gradient-to-br from-[#FF7A00] via-[#FF2A5F] to-[#00E5FF] blur-3xl"
        />
        {/* Central giant emoji */}
        <motion.div
          initial={{ scale: 0, rotate: -30 }}
          animate={{ scale: [0, 1.4, 1.1], rotate: [- 30, 10, 0] }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="relative"
        >
          <div className="text-[120px] leading-none drop-shadow-[0_0_30px_rgba(255,215,0,0.8)]">
            {gift.emoji}
          </div>
          <div className="mt-2 text-center font-outfit font-extrabold text-2xl text-white drop-shadow-lg">
            {gift.name}
          </div>
        </motion.div>
        {/* Burst ring */}
        {ring.map((_, i) => {
          const angle = (i / ring.length) * Math.PI * 2;
          const dx = Math.cos(angle) * 180;
          const dy = Math.sin(angle) * 180;
          return (
            <motion.div
              key={i}
              initial={{ x: 0, y: 0, opacity: 0, scale: 0.5 }}
              animate={{ x: dx, y: dy, opacity: [1, 1, 0], scale: 1.2 }}
              transition={{ duration: 0.9, delay: 0.15, ease: "easeOut" }}
              className="absolute text-3xl"
            >
              {gift.emoji}
            </motion.div>
          );
        })}
      </motion.div>
    </AnimatePresence>
  );
}
